import type { AxiosError, AxiosResponse } from 'axios';

import { ErrorCodes } from '@repo/lib/errorCodes';
import { isAxiosError } from 'axios';

export class AxiosInterceptorManager {
  private static instance: AxiosInterceptorManager | null = null;
  private sessionExpirationCb: () => void;

  private constructor(sessionExpirationCb: () => void) {
    this.sessionExpirationCb = sessionExpirationCb;
  }

  public static getInstance(sessionExpirationCb: () => void): AxiosInterceptorManager {
    if (!AxiosInterceptorManager.instance) {
      AxiosInterceptorManager.instance = new AxiosInterceptorManager(sessionExpirationCb);
    }
    return AxiosInterceptorManager.instance;
  }

  public async successResponseInterceptor<T = unknown>(response: AxiosResponse<T>): Promise<AxiosResponse<T>> {
    if (response.status >= 200 && response.status < 300) {
      return response;
    }
    throw new Error('API Error! Invalid status code!');
  }

  public errorResponseInterceptor<T = unknown, D = unknown>(error: AxiosError<T, D> | Error): Promise<never> {
    if (isAxiosError(error) && error.response?.data?.code) {
      const statusCode: string = error.response.data.code;
      if (statusCode === ErrorCodes.AUTH.NO_CRED) {
        return this.handleUnauthorizedError();
      }
    }
    return Promise.reject(error);
  }

  private handleUnauthorizedError(): Promise<never> {
    this.sessionExpirationCb();
    return Promise.reject(new Error('Session expired'));
  }
}
